import { Component, OnDestroy, OnInit } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { Subscription } from 'rxjs/Subscription';
import {
  IComplaintsDashboardView,
  IDashboardRepeatRow,
} from '../../../../../core/interfaces/complaints-dashboard.interface';
import { ComplaintsDashboardStore } from '../../complaints-dashboard.store';

const NO_ROWS_TEXT = 'No repeat members in this period.';

@Component({
  selector: 'app-dashboard-repeat-members',
  templateUrl: './dashboard-repeat-members.component.html',
  styleUrls: ['./dashboard-repeat-members.component.scss'],
})
export class DashboardRepeatMembersComponent implements OnInit, OnDestroy {
  grid: GridOptions;
  hint = '';

  private subscriptions: Subscription[] = [];

  constructor(private store: ComplaintsDashboardStore) {
    this.initGrid();
  }

  ngOnInit() {
    this.watchView();
  }

  private watchView() {
    this.subscriptions.push(
      this.store.view$.subscribe({
        next: (view: IComplaintsDashboardView) => {
          this.setRows(view ? view.repeatRows : []);
          this.hint = view ? view.repeatLabel : '';
        },
      }),
    );
  }

  private setRows(rows: IDashboardRepeatRow[]) {
    this.grid.rowData = rows;

    if (this.grid.api) {
      this.grid.api.setRowData(rows);
    }
  }

  private initGrid() {
    this.grid = <GridOptions>{
      enableColResize: true,
      enableSorting: false,
      enableFilter: false,
      suppressCellSelection: true,
      defaultColDef: {
        suppressMenu: true,
        suppressSorting: true,
      },
      columnDefs: [
        {
          headerName: 'Member',
          field: 'label',
          width: 150,
          tooltipField: 'label',
        },
        { headerName: 'DOB', field: 'dob', width: 84, suppressSizeToFit: true },
        {
          headerName: 'Total',
          field: 'total',
          width: 64,
          suppressSizeToFit: true,
          cellClass: ['text-a-right'],
        },
        { headerName: 'Top Type', field: 'top', width: 130, tooltipField: 'top' },
      ],
      rowData: [],
      overlayNoRowsTemplate: NO_ROWS_TEXT,
      onGridReady: (params) => {
        params.api.setRowData(this.grid.rowData || []);
        params.api.sizeColumnsToFit();
      },
      onModelUpdated: (params) => {
        params.api.sizeColumnsToFit();
      },
      onGridSizeChanged: (params) => {
        params.api.sizeColumnsToFit();
      },
    };
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/complaints/complaints-dashboard/components/dashboard-repeat-members/dashboard-repeat-members.component.ts